import { render, staticRenderFns } from "./DirectorPage.vue?vue&type=template&id=1f4ee34a&scoped=true&lang=pug&"
import script from "./DirectorPage.vue?vue&type=script&lang=js&"
export * from "./DirectorPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4ee34a",
  null
  
)

export default component.exports